import { connect } from 'react-redux';
import DisplayActions from '../../../../redux/DisplayRedux';
import UserAccountActions from '../../../../redux/UserAccountRedux';
import CampaignManagerComponent from '../components/CampaignManagerComponent';

const mapStateToProps = ({ display, userAccount }) => ({
  user: userAccount.user,
  token: userAccount.token,
  campaignName: display.campaignName,
  creationType: display.creationType,
  campaignCurrency: display.campaignCurrency,
  campaignInvoiceIssuingCountry: display.campaignInvoiceIssuingCountry,
  campaignDescription: display.campaignDescription,
  cart: display.cart,
  defaultContent: display.defaultContent,
  creatingCampaign: display.creatingCampaign,
  editingCampaign: display.editingCampaign,
  campaignAsyncOperation: display.campaignAsyncOperation,
  errors: display.errors,
  campaign: display.campaign,
  client: display.client,
  brand: display.brand,
  amountBudget: display.amountBudget,
  realAmount: display.realAmount,
  defaultRules: display.defaultRules,
  programmatic: display.programmatic,
  editCampaignActive: display.editCampaignActive,
  currentCampaign: display.currentCampaign,
  customContents: display.customContents,
  originalCustomContents: display.originalCustomContents,
  loadingUploadFile: display.loadingUploadFile,
  fileNew: display.fileNew,
  canva: display.canva,
  isCampaignTest: display.isCampaignTest,
  isCampaignPaused: display.isCampaignPaused,
  reportSingleData: display.reportSingleData,
  countries: userAccount.countries,
  currency: userAccount.currency,
  invoiceIssuingCountry: userAccount.invoiceIssuingCountry,
  audience: display.audience,
  date_from: display.date_from,
  date_to: display.date_to,
  displays: display.displays,
  dsp: display.dsp,
  isSuperUser: userAccount.isSuperUser,
  listResolutionWithContent: display.listResolutionWithContent,
  listOfContentsInCampaign: display.listOfContentsInCampaign,
  loadingContentsbyCompany: display.loadingContentsbyCompany,
  fetchingPlaceholders: display.fetchingPlaceholders,
  fetchingCampaign: display.fetchingCampaign,
  isPendingCurrentCampaign: display.amountBudget,
  payments: display.payments,
  toleranceResolution: display.toleranceResolution,
  listBundle: display.listBundle,
  isPaymentStatusApproved: display.isPaymentStatusApproved,
  categories: display.categories,
  categoriesId: display.categoriesId,
  i18n: display.i18n,
  listOfPlaceholdersInCampaign: display.listOfPlaceholdersInCampaign,
  listResolutionWithPlaceholders: display.listResolutionWithPlaceholders,
  creatingCampaign: display.creatingCampaign,
  campaign: display.campaign,
  loadingProposal: display.loadingProposal,
  proposalToken: display.proposalToken,
  isGuaranteed: display.isGuaranteed,
  selectedProposalId: display.selectedProposalId,
  pricesData: display.pricesData,
  calculatingPrices: display.calculatingPrices,
  pricesErrors: display.pricesErrors,
  pricesErrorStatus: display.pricesErrorStatus,
  initialBackup: display.initialBackup,
  hasInitialBackup: display.hasInitialBackup,
  conversionRates: display.conversionRates,
});

const mapStateToDispatch = dispatch => ({
  getAudience: data => dispatch(DisplayActions.getAudienceRequest(data)),
  setCreationType: creationType => dispatch(DisplayActions.setCreationType(creationType)),
  setCampaignName: campaignName => dispatch(DisplayActions.setCampaignName(campaignName)),
  setCampaignDescription: campaignDescription =>
    dispatch(DisplayActions.setCampaignDescription(campaignDescription)),
  setIsCampaignTest: isCampaignTest => dispatch(DisplayActions.setIsCampaignTest(isCampaignTest)),
  setIsCampaignPaused: isCampaignPaused =>
    dispatch(DisplayActions.setIsCampaignPause(isCampaignPaused)),
  setActive: isCampaignPaused =>
    dispatch(
      DisplayActions.updateFieldInCustomContents(
        null,
        isCampaignPaused ? 0 : 1,
        'active',
        'multiple'
      )
    ),
  updateContentName: (relationId, value) =>
    dispatch(DisplayActions.updateFieldInCustomContents(relationId, value, 'content', 'single')),
  togglePendingContent: (displayId, relationId, value) =>
    dispatch(DisplayActions.togglePendingContent(displayId, relationId, value, 'single')),
  setDefaultContent: content => dispatch(DisplayActions.setDefaultContent(content)),
  updateDefaultContentRequest: id => dispatch(DisplayActions.updateDefaultContentRequest(id)),
  updateCustomContents: customContents =>
    dispatch(DisplayActions.updateCustomContents(customContents)),
  updateSubsidizedPrice: (relationId, value, typePreview) =>
    dispatch(
      DisplayActions.updateFieldInCustomContents(relationId, value, 'subsidized_price', typePreview)
    ),
  logout: () => dispatch(UserAccountActions.userLogout()),
  setShouldPromptLogin: (value, target) =>
    dispatch(UserAccountActions.setShouldPromptLogin(value, target)),
  uploadFileRequest: file => dispatch(DisplayActions.uploadFileRequest(file)),
  setCanvaInit: canva => dispatch(DisplayActions.setCanvaInit(canva)),
  editCampaignInactive: campaign => dispatch(DisplayActions.editCampaignInactive(campaign)),
  editCampaignTotalPromisedShows: totalPromisedShows =>
    dispatch(DisplayActions.editCampaignTotalPromisedShows(totalPromisedShows)),
  updateRealAmount: realAmount => dispatch(DisplayActions.updateRealAmount(realAmount)),
  updateImpressionsDisplay: (displayId, relationId, impressions) =>
    dispatch(DisplayActions.updateImpressionsDisplay(displayId, relationId, impressions)),
  addCustomContentFromCampaign: (
    relationId,
    indice_relation,
    active,
    displayId,
    fill_screen,
    revision_status,
    isPendingContent,
    isContentMixed,
    promised_shows,
    length,
    content,
    rules,
    subsidized_price,
    promised_shows_subsidized,
    content_name,
    cpm,
    programmatic_volume_discount_apply,
    programmatic_volume_discounts,
    promised_shows_discounted,
    is_secured_investment,
    minimum_programmatic_spots,
    minimum_programmatic_period
  ) =>
    dispatch(
      DisplayActions.addCustomContentFromCampaign(
        relationId,
        indice_relation,
        active,
        displayId,
        fill_screen,
        revision_status,
        isPendingContent,
        isContentMixed,
        promised_shows,
        length,
        content,
        rules,
        subsidized_price,
        promised_shows_subsidized,
        content_name,
        cpm,
        programmatic_volume_discount_apply,
        programmatic_volume_discounts,
        promised_shows_discounted,
        is_secured_investment,
        minimum_programmatic_spots,
        minimum_programmatic_period
      )
    ),
  createCampaign: params => dispatch(DisplayActions.createCampaignRequest(params)),
  clearCustomContents: () => dispatch(DisplayActions.clearCustomContents()),
  editCampaign: (campaignId, params) =>
    dispatch(DisplayActions.editCampaignRequest(campaignId, params)),
  patchCampaignContentsDisplays: (campaignId, params) =>
    dispatch(DisplayActions.patchCampaignContentsDisplaysRequest(campaignId, params)),
  getCampaignPayments: id => dispatch(DisplayActions.getCampaignPaymentsRequest(id)),
  activateEditCampaign: campaign => dispatch(DisplayActions.activateEditCampaign(campaign)),
  setListOfContentsInCampaign: contents =>
    dispatch(DisplayActions.setListOfContentsInCampaign(contents)),
  updatePromiseShowsInRelations: customContents =>
    dispatch(DisplayActions.updatePromiseShowsInRelations(customContents)),
  getCategories: () => dispatch(DisplayActions.getCategoriesRequest()),
  setCategoriesId: categoriesId => dispatch(DisplayActions.setCategoriesId(categoriesId)),
  clearCampaignData: () => dispatch(DisplayActions.clearCampaignData()),
  userUpdate: user => dispatch(UserAccountActions.userUpdate(user)),
  setListResolutionWithContent: listResolutionWithContent =>
    dispatch(DisplayActions.setListResolutionWithContent(listResolutionWithContent)),
  resetPlaceholders: () => dispatch(DisplayActions.resetPlaceholders()),
  getProposalRequest: proposalData => dispatch(DisplayActions.getProposalRequest(proposalData)),
  resetCampaignData: () => dispatch(DisplayActions.resetCampaignData()),
  getCampaignRequest: id => dispatch(DisplayActions.getCampaignRequest(id)),
  addListDisplayToCart: displays => dispatch(DisplayActions.addListDisplayToCart(displays)),
  calculatePrices: params => dispatch(DisplayActions.calculateCampaignPricesRequest(params))
});

export default connect(mapStateToProps, mapStateToDispatch)(CampaignManagerComponent);
